<svg [attr.width]="size" [attr.height]="size" viewBox="0 0 24 24" [attr.fill]="fill"><path [attr.d]="path"/></svg>
